import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const downloadExcel = (data, fileName) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, fileName);
};

export const downloadExcelColorclmn = async (data, fileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    // Add all rows
    data.forEach((rowData) => {
        worksheet.addRow(headers.map((header) => rowData[header]));
    });

    // Determine which headers have at least one non-null/non-empty value
    const activeColumns = headers
        .map((header, index) => {
            return data.some(
                (row) =>
                    row[header] !== null &&
          row[header] !== undefined &&
          row[header] !== ""
            )
                ? index
                : null;
        })
        .filter((index) => index !== null);

    // Style only the active header cells
    const headerRow = worksheet.getRow(1);
    activeColumns.forEach((index) => {
        const cell = headerRow.getCell(index + 1); // ExcelJS is 1-based
        cell.font = { bold: true };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD3D3D3" }, // Light gray
        };
        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };
    });

    // Auto width for columns based on headers
    worksheet.columns.forEach((col, i) => {
        col.width = Math.max(15, headers[i]?.length || 15);
    });

    // Generate and download Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, fileName);
};

export const handleExportExcelloading = (
    summaryData,
    detailsData,
    filename
) => {
    const workbook = XLSX.utils.book_new();
    const summaryHeader = [
        [
            {
                v: "CASTROL INDIA LIMITED - LOADING LIST (Summary)",
                s: {
                    font: { bold: true, sz: 30, color: { rgb: "FFFFFF" } }, // Bold, font size 20, white text
                    fill: { fgColor: { rgb: "00FF00" } }, // Green background
                    alignment: { horizontal: "center", vertical: "center" }, // Center the text
                },
            },
        ],
    ];
    const summarySheet = XLSX.utils.json_to_sheet(summaryData, { origin: "A2" });
    XLSX.utils.sheet_add_aoa(summarySheet, summaryHeader, { origin: "A1" });

    summarySheet["!merges"] = [
        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: Object.keys(summaryData[0]).length - 1 },
        },
    ];

    XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

    const detailsHeader = [
        [
            {
                v: "CASTROL INDIA LIMITED - LOADING LIST (INVOICE WISE)",
                s: {
                    font: { bold: true, sz: 20, color: { rgb: "FFFFFF" } }, // Bold, font size 20, white text
                    fill: { fgColor: { rgb: "00FF00" } }, // Green background
                    alignment: { horizontal: "center", vertical: "center" }, // Center the text
                },
            },
        ],
    ];

    const detailsSheet = XLSX.utils.json_to_sheet(detailsData, { origin: "A2" });
    XLSX.utils.sheet_add_aoa(detailsSheet, detailsHeader, { origin: "A1" });

    detailsSheet["!merges"] = [
        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: Object.keys(detailsData[0]).length - 1 },
        },
    ];
    XLSX.utils.book_append_sheet(workbook, detailsSheet, "Details");
    XLSX.writeFile(workbook, filename);
};
